import { Loading360 } from 'components/loading/Loading360';
import { lazy, Suspense } from 'react';

import { ProviderPlanningByLevel } from '../planningByLevel/context/ContextPlanningByLevel';

const PlanningLevelConfiguration = lazy(
	() => import('../planningLevelConfiguration/PlanningLevelConfiguration')
);
const PlanningByLevel = lazy(
	() => import('../planningByLevel/PlanningByLevel')
);
const DetailedPlanning = lazy(
	() => import('../detailedPlanning/DetailedPlanning')
);

const Loading360Fallback = (
	<Loading360
		size={48}
		variant='gradient'
		table={true}
		message={true}
	/>
);

const PlanningTabsData = [
	{
		label: 'Previsão por Nível',
		content: (
			<Suspense fallback={Loading360Fallback}>
				<ProviderPlanningByLevel>
					<PlanningByLevel />
				</ProviderPlanningByLevel>
			</Suspense>
		),
	},
	{
		label: 'Previsão Detalhada',
		content: (
			<Suspense fallback={Loading360Fallback}>
				<DetailedPlanning />
			</Suspense>
		),
	},
	{
		label: 'Configuração da Previsão por Nível',
		content: (
			<Suspense fallback={Loading360Fallback}>
				<PlanningLevelConfiguration />
			</Suspense>
		),
	},
];

export default PlanningTabsData;
